import { Badge } from '@/components/ui/badge';
import { PriorityLevel } from '@/data/horizonScanningTypes';
import { cn } from '@/lib/utils';

interface PriorityBadgeProps {
  score: number;
  level: PriorityLevel;
  className?: string;
}

export function PriorityBadge({ score, level, className }: PriorityBadgeProps) {
  const getVariant = () => {
    switch (level) {
      case 'High':
        return 'destructive';
      case 'Medium':
        return 'warning';
      case 'Low':
        return 'success';
      default:
        return 'default';
    }
  };

  const getEmoji = () => {
    switch (level) {
      case 'High':
        return '🔴';
      case 'Medium':
        return '🟠';
      case 'Low':
        return '🟢';
      default:
        return '';
    }
  };

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Badge variant={getVariant()} className="w-fit">
        {getEmoji()} {score}/100 ({level})
      </Badge>
      <div className="text-xs text-muted-foreground">
        {level === 'High' && 'Critical Update'}
        {level === 'Medium' && 'Procedural Review'}
        {level === 'Low' && 'Minor Admin'}
      </div>
    </div>
  );
}